




















































































































































































import Vue from 'vue'
import { AxiosError } from 'axios'
import { sic } from '@rhitics/core'

export default Vue.extend({
  name: 'AddAssetsDialog',
  data() {
    return {
      batchName: '',
      inputType: ('File' as 'File') || 'Form',
      files: [],
      loading: false,
      dialog: false,
      form: {
        vaild: true,
        batchOptions: [] as string[],
        batch: '',
        keeper: '',
        keeperDepartment: '',
        name: '',
        number: '',
        quantity: 0
      },
      alert: {
        text: '',
        color: 'error',
        switch: false,
        timeout: 6000
      }
    }
  },
  async created() {
    this.form.batchOptions = (await sic.asset.option({ batchs: ['*'] })).data
    this.form.batch = this.form.batchOptions[0]
  },
  methods: {
    async submit() {
      this.loading = true
      try {
        if (this.inputType === 'File') {
          const response = await sic.asset.upload(this.batchName, this.files[0])
          this.promoteAlert(true, response.message, 'success')
        } else {
          if (this.form.vaild === false) throw ''
          const response = await sic.asset.create({
            batch: this.form.batch,
            keeper: this.form.keeper,
            keeperDepartment: this.form.keeperDepartment,
            name: this.form.name,
            number: this.form.number,
            quantity: this.form.quantity
          })
          this.promoteAlert(true, response.message, 'success')
        }
        this.resetForm()
        this.$emit('conditionUpdate')
      } catch (error) {
        error = error as AxiosError
        this.promoteAlert(
          true,
          error?.response?.data?.message + 'Reson: ' + JSON.stringify(error?.response?.data?.errors),
          'error',
          0
        )
      }
      this.loading = false
    },
    resetForm() {
      this.form.keeper = ''
      this.form.keeperDepartment = ''
      this.form.name = ''
      this.form.number = ''
      this.form.quantity = 0
    },
    promoteAlert(open = false, text = '', color = 'error', timeout: number = 6000) {
      this.alert.switch = open
      this.alert.text = text
      this.alert.color = color
      this.alert.timeout = timeout
    }
  }
})
